import { HttpMethod, RequestConfig } from '../types';
import { prepareBody } from './prepareBody';

export const prepareRequest = (
  method: HttpMethod,
  config: RequestConfig,
  getToken: () => string | null
): Pick<RequestInit, 'headers' | 'body'> => {
  if (method === 'GET' && config.body) {
    throw new Error('GET request cannot have body');
  }

  const token = getToken();

  // prepare body + base headers
  const { headers, body } = prepareBody(config.body, config.headers);

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return { headers, body };
};
